import { matchYbrLender, panelKey, YBR_PANEL } from "./ybr-panel";

export { panelKey, YBR_PANEL };

/** Lenders this brokerage can place. Never surface the aggregator name in the UI. */
export function isPanelLender(lender: string): boolean {
  return matchYbrLender(lender) != null;
}

export function filterPanel<T extends { lender: string }>(rows: T[]): T[] {
  return rows.filter((row) => isPanelLender(row.lender));
}
